
export interface CategoryHierarchy {
  id: string;
  name: string;
  subcategories?: {
    id: string;
    name: string;
  }[];
}

export const categories: CategoryHierarchy[] = [
  {
    id: "cs",
    name: "Computer Science",
    subcategories: [
      { id: "cs.AI", name: "Artificial Intelligence" },
      { id: "cs.AR", name: "Hardware Architecture" },
      { id: "cs.CC", name: "Computational Complexity" },
      { id: "cs.CE", name: "Computational Engineering, Finance, and Science" },
      { id: "cs.CG", name: "Computational Geometry" },
      { id: "cs.CL", name: "Computation and Language" },
      { id: "cs.CR", name: "Cryptography and Security" },
      { id: "cs.CV", name: "Computer Vision and Pattern Recognition" },
      { id: "cs.CY", name: "Computers and Society" },
      { id: "cs.DB", name: "Databases" },
      { id: "cs.DC", name: "Distributed, Parallel, and Cluster Computing" },
      { id: "cs.DL", name: "Digital Libraries" },
      { id: "cs.DM", name: "Discrete Mathematics" },
      { id: "cs.DS", name: "Data Structures and Algorithms" },
      { id: "cs.ET", name: "Emerging Technologies" },
      { id: "cs.FL", name: "Formal Languages and Automata Theory" },
      { id: "cs.GL", name: "General Literature" },
      { id: "cs.GR", name: "Graphics" },
      { id: "cs.GT", name: "Computer Science and Game Theory" },
      { id: "cs.HC", name: "Human-Computer Interaction" },
      { id: "cs.IR", name: "Information Retrieval" },
      { id: "cs.IT", name: "Information Theory" },
      { id: "cs.LG", name: "Machine Learning" },
      { id: "cs.LO", name: "Logic in Computer Science" },
      { id: "cs.MA", name: "Multiagent Systems" },
      { id: "cs.MM", name: "Multimedia" },
      { id: "cs.MS", name: "Mathematical Software" },
      { id: "cs.NA", name: "Numerical Analysis" },
      { id: "cs.NE", name: "Neural and Evolutionary Computing" },
      { id: "cs.NI", name: "Networking and Internet Architecture" },
      { id: "cs.OH", name: "Other Computer Science" },
      { id: "cs.OS", name: "Operating Systems" },
      { id: "cs.PF", name: "Performance" },
      { id: "cs.PL", name: "Programming Languages" },
      { id: "cs.RO", name: "Robotics" },
      { id: "cs.SC", name: "Symbolic Computation" },
      { id: "cs.SD", name: "Sound" },
      { id: "cs.SE", name: "Software Engineering" },
      { id: "cs.SI", name: "Social and Information Networks" },
      { id: "cs.SY", name: "Systems and Control" },
    ]
  },
  {
    id: "math",
    name: "Mathematics",
    subcategories: [
      { id: "math.AC", name: "Commutative Algebra" },
      { id: "math.AG", name: "Algebraic Geometry" },
      { id: "math.AP", name: "Analysis of PDEs" },
      { id: "math.AT", name: "Algebraic Topology" },
      { id: "math.CA", name: "Classical Analysis and ODEs" },
      { id: "math.CO", name: "Combinatorics" },
      { id: "math.CT", name: "Category Theory" },
      { id: "math.CV", name: "Complex Variables" },
      { id: "math.DG", name: "Differential Geometry" },
      { id: "math.DS", name: "Dynamical Systems" },
      { id: "math.FA", name: "Functional Analysis" },
      { id: "math.GM", name: "General Mathematics" },
      { id: "math.GN", name: "General Topology" },
      { id: "math.GR", name: "Group Theory" },
      { id: "math.GT", name: "Geometric Topology" },
      { id: "math.HO", name: "History and Overview" },
      { id: "math.IT", name: "Information Theory" },
      { id: "math.KT", name: "K-Theory and Homology" },
      { id: "math.LO", name: "Logic" },
      { id: "math.MG", name: "Metric Geometry" },
      { id: "math.MP", name: "Mathematical Physics" },
      { id: "math.NA", name: "Numerical Analysis" },
      { id: "math.NT", name: "Number Theory" },
      { id: "math.OA", name: "Operator Algebras" },
      { id: "math.OC", name: "Optimization and Control" },
      { id: "math.PR", name: "Probability" },
      { id: "math.QA", name: "Quantum Algebra" },
      { id: "math.RA", name: "Rings and Algebras" },
      { id: "math.RT", name: "Representation Theory" },
      { id: "math.SG", name: "Symplectic Geometry" },
      { id: "math.SP", name: "Spectral Theory" },
      { id: "math.ST", name: "Statistics Theory" },
    ]
  },
  {
    id: "physics",
    name: "Physics",
    subcategories: [
      { id: "physics.acc-ph", name: "Accelerator Physics" },
      { id: "physics.ao-ph", name: "Atmospheric and Oceanic Physics" },
      { id: "physics.app-ph", name: "Applied Physics" },
      { id: "physics.atm-clus", name: "Atomic and Molecular Clusters" },
      { id: "physics.atom-ph", name: "Atomic Physics" },
      { id: "physics.bio-ph", name: "Biological Physics" },
      { id: "physics.chem-ph", name: "Chemical Physics" },
      { id: "physics.class-ph", name: "Classical Physics" },
      { id: "physics.comp-ph", name: "Computational Physics" },
      { id: "physics.data-an", name: "Data Analysis, Statistics and Probability" },
      { id: "physics.ed-ph", name: "Physics Education" },
      { id: "physics.flu-dyn", name: "Fluid Dynamics" },
      { id: "physics.gen-ph", name: "General Physics" },
      { id: "physics.geo-ph", name: "Geophysics" },
      { id: "physics.hist-ph", name: "History and Philosophy of Physics" },
      { id: "physics.ins-det", name: "Instrumentation and Detectors" },
      { id: "physics.med-ph", name: "Medical Physics" },
      { id: "physics.optics", name: "Optics" },
      { id: "physics.plasm-ph", name: "Plasma Physics" },
      { id: "physics.pop-ph", name: "Popular Physics" },
      { id: "physics.soc-ph", name: "Physics and Society" },
      { id: "physics.space-ph", name: "Space Physics" },
      // ArXiv physics categories
      { id: "astro-ph", name: "Astrophysics" },
      { id: "cond-mat", name: "Condensed Matter" },
      { id: "gr-qc", name: "General Relativity and Quantum Cosmology" },
      { id: "hep-ex", name: "High Energy Physics - Experiment" },
      { id: "hep-lat", name: "High Energy Physics - Lattice" },
      { id: "hep-ph", name: "High Energy Physics - Phenomenology" },
      { id: "hep-th", name: "High Energy Physics - Theory" },
      { id: "math-ph", name: "Mathematical Physics" },
      { id: "nlin", name: "Nonlinear Sciences" },
      { id: "nucl-ex", name: "Nuclear Experiment" },
      { id: "nucl-th", name: "Nuclear Theory" },
      { id: "quant-ph", name: "Quantum Physics" },
    ]
  },
  {
    id: "econ",
    name: "Economics",
    subcategories: [
      { id: "econ.EM", name: "Econometrics" },
      { id: "econ.GN", name: "General Economics" },
      { id: "econ.TH", name: "Theoretical Economics" },
    ]
  },
  {
    id: "eess",
    name: "Electrical Engineering and Systems Science",
    subcategories: [
      { id: "eess.AS", name: "Audio and Speech Processing" },
      { id: "eess.IV", name: "Image and Video Processing" },
      { id: "eess.SP", name: "Signal Processing" },
      { id: "eess.SY", name: "Systems and Control" },
    ]
  },
  {
    id: "q-bio",
    name: "Quantitative Biology",
    subcategories: [
      { id: "q-bio.BM", name: "Biomolecules" },
      { id: "q-bio.CB", name: "Cell Behavior" },
      { id: "q-bio.GN", name: "Genomics" },
      { id: "q-bio.MN", name: "Molecular Networks" },
      { id: "q-bio.NC", name: "Neurons and Cognition" },
      { id: "q-bio.OT", name: "Other Quantitative Biology" },
      { id: "q-bio.PE", name: "Populations and Evolution" },
      { id: "q-bio.QM", name: "Quantitative Methods" },
      { id: "q-bio.SC", name: "Subcellular Processes" },
      { id: "q-bio.TO", name: "Tissues and Organs" },
    ]
  },
  {
    id: "q-fin",
    name: "Quantitative Finance",
    subcategories: [
      { id: "q-fin.CP", name: "Computational Finance" },
      { id: "q-fin.EC", name: "Economics" },
      { id: "q-fin.GN", name: "General Finance" },
      { id: "q-fin.MF", name: "Mathematical Finance" },
      { id: "q-fin.PM", name: "Portfolio Management" },
      { id: "q-fin.PR", name: "Pricing of Securities" },
      { id: "q-fin.RM", name: "Risk Management" },
      { id: "q-fin.ST", name: "Statistical Finance" },
      { id: "q-fin.TR", name: "Trading and Market Microstructure" },
    ]
  },
  {
    id: "stat",
    name: "Statistics",
    subcategories: [
      { id: "stat.AP", name: "Applications" },
      { id: "stat.CO", name: "Computation" },
      { id: "stat.ME", name: "Methodology" },
      { id: "stat.ML", name: "Machine Learning" },
      { id: "stat.OT", name: "Other Statistics" },
      { id: "stat.TH", name: "Statistics Theory" },
    ]
  },
];
